export { getAutofillString } from '../../views/BookingForm/utils';

export const getErrorMessage = ({ id, title, error, errors }) => {
  const errored = !!(error || errors?.[id]);
  const errorMessage = errored
    ? error || errors?.[id]?.message || `${title} invalid`
    : null;

  return errorMessage;
};
